import { useState } from 'react';
import { CButton, CContainer, CCollapse, CDropdown, CDropdownDivider, CDropdownHeader, CDropdownItem, CDropdownItemPlain, CDropdownMenu, CDropdownToggle, CForm, CFormInput, CInputGroup, CInputGroupText, CNav, CNavItem, CNavLink, CNavbar, CNavbarBrand, CNavbarNav, CNavbarText, CNavbarToggler, COffcanvas, COffcanvasBody, COffcanvasHeader, COffcanvasTitle } from '@coreui/bootstrap-react/src/index';
import CoreUISignetImg from "../../../../content/1.0/assets/images/brand/coreui-signet.svg";
import * as React from 'react';
export default {
  useState,
  CButton,
  CContainer,
  CCollapse,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownItemPlain,
  CDropdownMenu,
  CDropdownToggle,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CNav,
  CNavItem,
  CNavLink,
  CNavbar,
  CNavbarBrand,
  CNavbarNav,
  CNavbarText,
  CNavbarToggler,
  COffcanvas,
  COffcanvasBody,
  COffcanvasHeader,
  COffcanvasTitle,
  CoreUISignetImg,
  React
};